/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createCos } from '../../factoriesAny.js';
export var cosDependencies = {
  typedDependencies,
  createCos
};